<template>
  <!-- 账号管理设置页面 -->
  <!-- 设置页面的内容区域 -->
  <div class="config_main_manage_page_wraper">
    <div class="config_main_manage_page_content">
      <!-- 设置页面  内容区域样式   以上部分都是公共样式 -->
      <config-title-hang class="config_hight_change_account_number_manage">
        <span slot="config_title_hang_ele4">右击可删除一个子账号</span>
        <img
          slot="config_title_hang_ele3"
          src="~assets/img/config/tishilaba.png"
          alt
        />
      </config-title-hang>

      <config-hang @click.native="configChangeAccountNumberBtnHandle">
        <img
          slot="config_hang_ele1"
          src="~assets/img/message/xinxi_haoyou.png"
          alt
        />

        <span slot="config_hang_ele2">主账号</span>
        <span slot="config_hang_ele3">{{ account }}</span>

        <img
          slot="config_hang_ele4"
          src="~assets/img/config/youjiantou.png"
          alt
        />
      </config-hang>

      <config-title-hang>
        <span slot="config_title_hang_ele2">已有子账号列表</span>
        <img
          slot="config_title_hang_ele5_img"
          src="~assets/img/config/add_baise.png"
          @click="addSonAccountNumber"
          alt
        />
        <span slot="config_title_hang_ele5" @click="addSonAccountNumber"
          >添加子账号</span
        >
      </config-title-hang>

      <config-hang
        v-for="(value, index) in ServeSonAccountData"
        :key="index + new Date().getTime()"
        @click.native="xiuGaiZAccountNumberBtnHandle(value)"
        @contextmenu.prevent.native="
          oneZAccountNumberRightClickBtnHandle(value, index)
        "
      >
        <span slot="config_hang_ele2">{{ index + 1 }}.子账号</span>
        <span slot="config_hang_ele3">{{ value.account }}</span>
        <img
          slot="config_hang_ele4"
          src="~assets/img/config/youjiantou.png"
          alt
        />
      </config-hang>
    </div>
  </div>
</template>

<script>
import configHang from 'components/common/config/config-hang'
import configTitleHang from 'components/common/config/config-title-hang'
export default {
  data() {
    return {
      oneServeSonAccountData: {
        account: '',
        accountId: '',
        controlType: 0,
        regionList: [],
        userId: ''
      },
      ServeSonAccountData: [
        //服务器获取的所有子账号列表
      ],
      userPassWord: '',
      CuserPassWord: '',
      account: sessionStorage.getItem('account') //获取用户账户信息
    }
  },
  components: {
    configHang,
    configTitleHang
  },
  methods: {
    configChangeAccountNumberBtnHandle() {
      ////主账号按钮
      this.$router.push('AccountNumberInfoManage')
    },
    xiuGaiZAccountNumberBtnHandle(value) {
      ///子账号按钮
      this.$store.dispatch('asyUpdataOneServeSonAccountData', value) ///提交默认账号数据到仓库以便回显
      this.$store.dispatch('asyUpdataSelectRegionList', value.regionList) ///提交默认勾选区域到仓库
      this.$store.dispatch('asyUpdatauserPassWord', '********') ///提交用户密码
      this.$store.dispatch('asyUpdataCuserPassWord', '********') ///提交用户的再次输入密码

      this.$router.push('addSonAccountNumber')
    },
    oneZAccountNumberRightClickBtnHandle(value, index) {
      ////一个子账号的右击事件
      console.log('子账号的右击事件')
      this.$showTipsToast(8, this.ServeSonAccountData, false, 1000, index)
      console.log(this.ServeSonAccountData)
    },
    addSonAccountNumber() {
      ///添加一个子账号按钮被点击了

      this.$store.dispatch(
        'asyUpdataOneServeSonAccountData',
        this.oneServeSonAccountData
      ) ///提交默认账号数据到仓库以便回显
      this.$store.dispatch(
        'asyUpdataSelectRegionList',
        this.oneServeSonAccountData.regionList
      ) ///提交默认勾选区域到仓库
      this.$store.dispatch('asyUpdatauserPassWord', this.userPassWord) ///提交用户密码
      this.$store.dispatch('asyUpdataCuserPassWord', this.CuserPassWord) ///提交用户的再次输入密码

      this.$router.push('addSonAccountNumber')
    }
  },

  mounted() {
    console.log('mounted阶段')
  },
  created() {
    console.log('created阶段')
    /// 获取子账号列表接口，获取数据
    this.$request({
      method: 'post',
      url: '/user/findSubAccountList',
      data: {
        token: this.$store.state.token
      }
    })
      .then(res => {
        if (res.data.code != 0) {
          this.$showTipsToast(3, res.data.message)
          ////说明信息填写错误,控制失败了，
          return
        } else {
          ////、控制成功了
          this.ServeSonAccountData = res.data.data ////拿到服务器返回的数据结果
          // this.$store.dispatch("asyUpdataServeSceneData", this.ServeSceneData); ///异步提交信息到仓库
          // this.$showTipsToast(1, "获取成功", true); ////提示框
        }
      })
      .catch(error => {
        console.log(error)
      })
  }
}
</script>

<style>
.config_hight_change_account_number_manage {
  height: 40px;
  line-height: 40px;
}
.config_hight_change_account_number_manage img {
  right: 195px;
}
</style>
